// Angular modules
import { NgModule } from '@angular/core';

// Kendo-UI modules
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

// TrazeLab shared components
import { DropDownListFilterComponent } from '@app/shared/component/dropdownlist-filter/dropdownlist-filter.component';
import { AutoFocusDirective } from '@app/shared/component/auto-focus/auto-focus-directive';

@NgModule({
  imports: [DropDownsModule],
  declarations: [DropDownListFilterComponent,
                 AutoFocusDirective],
  exports: [AutoFocusDirective, DropDownListFilterComponent]
})
export class ComponentModule { }
